/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';

export default function () {
	extend(UserPage.prototype, 'navItems', function (items) {
		// `user.reviews` is routed in ./setupRouting.
		items.add(
			'reviews',
			// `navItems()` only runs once the page has loaded its user.
			<LinkButton icon="far fa-heart" href={app.route('user.reviews', { username: this.user!.slug() })}>
				{app.translator.trans('glowingblue-orell-rezensionen.forum.user.reviews_link')}
				<span className="Button-badge">{this.user!.reviewCount()}</span>
			</LinkButton>,
			200
		);

		items.setPriority('discussions', 190);
	});
}
